// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {PutVoucherSuccess} from 'redux/v1/voucher/put/actions';
import type {PutVoucher} from 'redux/v1/voucher/put/models';
import type {PutState} from 'redux/v1/voucher/put/PutState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  PURE,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {PUT_VOUCHER, RESET_ERROR} from 'redux/v1/voucher/put/actions';
import {putState} from 'redux/v1/voucher/VoucherState';

export const initialState: PutState = {
  loading: false,
};

const actionCreators: ActionHandlers<PutState> = {
  [PENDING(PUT_VOUCHER)]: (state: PutState) => ({
    ...state,
    loading: true,
    data: {
      value: 0,
      message: '',
      errorCode: '',
      codeType: '',
    },
  }),
  [SUCCESS(PUT_VOUCHER)]: (state: PutState, action: PutVoucherSuccess) => ({
    ...state,
    loading: false,
    data: action.data,
  }),
  [ERROR(PUT_VOUCHER)]: (state: PutState, action: any) => ({
    ...state,
    loading: false,
    error: action.error,
  }),
  [PURE(RESET_ERROR)]: (state: PutState, action: any) => ({
    ...state,
    data: {
      ...action.voucher,
      message: '',
      errorCode: '',
      valid: '',
    },
  }),
};

export const putReducer: Reducer<PutState> =
  // $FlowIgnore
  createReducerUsingActionHandlers<PutState>(initialState, actionCreators);

export const getVoucher: Selector<PutVoucher> = createSelector(
  putState,
  (state: PutState) => state.data
);

export const getVoucherCode: Selector<PutVoucher> = createSelector(
  putState,
  (state: PutState) => state.data?.code
);

export const getVoucherValue: Selector<PutVoucher> = createSelector(
  putState,
  (state: PutState) => state.data?.value
);

export const getMessage: Selector<string> = createSelector(
  putState,
  (state: PutState) => state.data?.message
);

export const getErrorCode: Selector<string> = createSelector(
  putState,
  (state: PutState) => state.data?.errorCode
);
